import { EHttpMethods } from "../../../../enums";
import { TRANSFERS_BASE_URL } from "./constants";
import { ApiServiceManager, fetchRequest } from "../../apiServiceManager";
import { getToken } from "../../../context/authContext";
import { ICompletedTransferResponse } from "./models";

const defaultProvide = async () => await getToken();

export const getCompletedTransfers = (body: {
  beneficiaryId?: string;
  transactionId?: string;
  page: number;
  size: number;
}): Promise<ICompletedTransferResponse> => {
  const params = new URLSearchParams();
  if (body?.beneficiaryId) params.append("beneficiaryId", body.beneficiaryId);
  if (body?.transactionId) params.append("domainId", body.transactionId);
  params.append("page", String(body?.page || 0));
  params.append("size", String(body?.size || 10));
  params.append("sort", "createdAt,desc");

  const url = `${TRANSFERS_BASE_URL}/cash-outs?${params.toString()}`;
  const descriptor = new ApiServiceManager(
    url,
    EHttpMethods.GET,
    defaultProvide
  );
  return fetchRequest(descriptor);
};
